// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventProvisioningIssuerData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.eventlogger.EventProvisioningIssuerDataOpenID4VCI

fun EventProvisioningIssuerData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "KYsKKiciH030mMz1Aq_s90Zz5G81Swt7EfAnWUD1b9g")
val EventProvisioningIssuerData_cborSchemaId = ByteString(41, -117, 10, 42, 39, 34, 31, 77, -12, -104, -52, -11, 2, -81, -20, -9, 70, 115, -28, 111, 53, 75, 11, 123, 17, -16, 39, 89, 64, -11, 111, -40)

fun EventProvisioningIssuerData.Companion.fromCbor(data: ByteArray): EventProvisioningIssuerData {
    return EventProvisioningIssuerData.fromDataItem(Cbor.decode(data))
}

val EventProvisioningIssuerData.Companion.cborSchemaId: ByteString
    get() = EventProvisioningIssuerData_cborSchemaId

fun EventProvisioningIssuerData.toDataItem(): DataItem {
    return when (this) {
        is EventProvisioningIssuerDataOpenID4VCI -> (this as EventProvisioningIssuerDataOpenID4VCI).toDataItem()
    }
}

fun EventProvisioningIssuerData.Companion.fromDataItem(dataItem: DataItem): EventProvisioningIssuerData {
    val type = dataItem["type"].asTstr
    return when (type) {
        "OpenID4VCI" -> EventProvisioningIssuerDataOpenID4VCI_fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
